import type { BridgeRunResult } from './RequestModelingResponse';

export type MCPBridgeAPI = {
  requestModeling: (viewModelId: string, instruction: string) => Promise<BridgeRunResult>;
};

let _api: MCPBridgeAPI | null = null;

export const MCPBridgeOperationLocator = {
  register(api: MCPBridgeAPI): void {
    _api = api;
  },
  unregister(api?: MCPBridgeAPI): void {
    if (api === undefined || _api === api) {
      _api = null;
    }
  },
  get(): MCPBridgeAPI | null {
    return _api;
  },
};
